export default __webpack_public_path__ + "static/media/about.6f36fce2.jpg";